/** Row from POST mytask/ActiveTask/taskActivityLog */
export interface TaskActivityLogEntry {
  id: string;
  task_id: string;
  user_id: string;
  active_status: string;
  comment: string;
  reason: string | null;
  ip_address?: string;
  created_at: string;
  firstname: string;
  lastname: string;
}
